import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["backgroundColor", "open", "children", "header", "marginTop", "overflow"];
import { createPortal } from 'react-dom';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import styled, { useTheme } from 'foundations-theming/utils';
import useDisableBodyScroll from '../../../hooks/useDisableBodyScroll';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OverlayContent = styled.div.withConfig({
  displayName: "FullScreenModal__OverlayContent"
})(["position:fixed;top:0;bottom:0;left:0;right:0;z-index:1111;background-color:", ";transition:", ";opacity:", ";transform:", ";pointer-events:", ";overflow:", ";margin-top:", ";"], ({
  overlayBackgroundColor
}) => overlayBackgroundColor, ({
  open
}) => open ? `transform 300ms ease-out` : `transform 300ms ease-out,
    opacity 0s 300ms`, ({
  open
}) => open ? '1' : '0', ({
  open
}) => open ? 'translateY(0%)' : 'translateY(100%)', ({
  open
}) => open ? 'auto' : 'none', ({
  overflow
}) => overflow || 'auto', ({
  marginTop
}) => marginTop);
const StickyHeaderWrapper = styled.div.withConfig({
  displayName: "FullScreenModal__StickyHeaderWrapper"
})(["position:sticky;top:0;z-index:1;width:100%;"]);
const FullScreenModal = _ref => {
  let {
      backgroundColor = 'fill-surface-default',
      open = false,
      children,
      header,
      marginTop,
      overflow
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  useDisableBodyScroll(open);
  return /*#__PURE__*/createPortal(
  /*#__PURE__*/
  // @bend-expect trellis-tokenized
  _jsx(OverlayContent, Object.assign({
    "data-test-is-showing": open,
    marginTop: marginTop,
    open: open,
    overflow: overflow,
    overlayBackgroundColor: theme.color[backgroundColor]
  }, restProps, {
    children: /*#__PURE__*/_jsxs(Flex, {
      blockSize: "100%",
      flexDirection: "column",
      children: [header &&
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(StickyHeaderWrapper, {
        children: header
      }), /*#__PURE__*/_jsx(Box, {
        grow: 1,
        inlineSize: "100%",
        children: children
      })]
    })
  })), document.body);
};
export default FullScreenModal;